import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Breadcrumbs } from "./Breadcrumbs";
import { formatBalance } from "../../utils/formatters";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: transparent;
  box-shadow: 0 0 0.35rem #000a;
  border: 1px solid black;
  border-radius: 5px;
  margin: 0.25rem 1rem 1rem;
`;

const TitleContainer = styled.div`
  border-bottom: 1px solid black;
  margin: 0.25rem;
  font-size: 2rem;
  padding: 0.5rem;
`;

const SummaryContainer = styled.div`
  border-top: 1px solid black;
  margin: 0.25rem;
  font-size: 2rem;
  padding: 0.5rem;
`;

const Title = styled.div`
  margin: 0.15rem;
  text-shadow: 0 0 1rem #000a;
`;

const Content = styled.div`
  padding: 1rem;
  flex-grow: 2;
`;

export const ResultColumn = ({ title, transfers, children }) => (
  <Container>
    <TitleContainer>
      <Title>{title}</Title>
    </TitleContainer>
    <Content>{children}</Content>
    <SummaryContainer>
      <Breadcrumbs>
        Jest winien w sumie:{" "}
        {formatBalance(
          transfers.reduce((acc, transfer) => acc + transfer.amount, 0)
        )}
      </Breadcrumbs>
    </SummaryContainer>
  </Container>
);

ResultColumn.propTypes = {
  title: PropTypes.string.isRequired,
};
